import type {
  CoorumResearchArgs,
  CoorumResearchMethod,
  WindowCoorumResearch,
} from '@coorum-research/shared-common/types/research-setting.type'
import { ResearchSdkManager } from './research-sdk-manager'

export class ResearchSdkFactory {
  readonly #sdkManager: ResearchSdkManager

  constructor(queue: CoorumResearchArgs[]) {
    // console.log('CoorumResearchSdkCore constructor')
    this.#sdkManager = new ResearchSdkManager(queue)
  }

  /**
   * sdk interfaceの型のfunctionを返す
   */
  getSdk(): WindowCoorumResearch {
    const sdkManager = this.#sdkManager

    return (method: CoorumResearchMethod, ...args: any[]): void => {
      switch (method) {
      case 'init':
        // console.log('CoorumResearchSdkCore init')
        sdkManager.init(args[0], args[1], args[2])
        break
      case 'boot':
        // console.log('CoorumResearchSdkCore boot')
        sdkManager.boot(args[0], args[1])
        break
      case 'showMyPage':
        // console.log('CoorumResearchSdkCore showMyPage')
        sdkManager.showMyPage()
        break
      case 'currentUserData':
        // console.log('CoorumResearchSdkCore currentUserData')
        sdkManager.currentUserData(args[0], args[1])
        break
      default:
        console.error(`Unknown coorum research api: ${method}`)
      }
    }
  }
}
